import React from "react";
import { Link } from "react-router-dom";

type Props = {
  to: string,
  children: React.ReactNode,
  className? : string,
  style?: React.CSSProperties,
};

const GrayLink = ({
  to,
  children,
  className,
  style,
} : Props) => {
  let linkStyle = "text-gray-700 text-sm";

  if (className) {
    linkStyle = `${linkStyle} ${className}`;
  }

  return (
    <Link
      to={to}
      reloadDocument
      className={linkStyle}
      style={style}
    >
      {children}
    </Link>
  );
};

export default GrayLink;
